import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./header";
import SideBar from "./sidebar";
import Login from "../pages/login";
import PreLoader from "./preloader";
import DailyBonusModal from "../components/home/daily_bonus";

export default function MainLayout() {
  const location = useLocation();
  const [isRouteLoading, setIsRouteLoading] = React.useState(true);
  const pageMainRef = React.useRef(null);

  React.useEffect(() => {
    const timer = window.setTimeout(() => {
      setIsRouteLoading(false);
    }, 300);

    return () => window.clearTimeout(timer);
  }, []);

  React.useEffect(() => {
    const handleNavigationStart = () => {
      setIsRouteLoading(true);
    };
    const handleNavigationEnd = () => {
      setIsRouteLoading(false);
    };

    window.addEventListener("app:navigation-start", handleNavigationStart);
    window.addEventListener("app:navigation-end", handleNavigationEnd);

    return () => {
      window.removeEventListener("app:navigation-start", handleNavigationStart);
      window.removeEventListener("app:navigation-end", handleNavigationEnd);
    };
  }, []);

  React.useEffect(() => {
    if (pageMainRef.current) {
      pageMainRef.current.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    const timer = window.setTimeout(() => {
      setIsRouteLoading(false);
    }, 260);

    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
    <PreLoader active={isRouteLoading} />
    <div className="page-wrapper">
      <Header />
      <DailyBonusModal />
      <div className="page-content">
        <SideBar />
        <main className="page-main" ref={pageMainRef}>
          <Outlet />
        </main>
      </div>
      <Login />
    </div>
    </>
  );
}
